import { render, staticRenderFns } from "./CardTagRowV2026.vue?vue&type=template&id=71ab8ef5&scoped=true"
import script from "./CardTagRowV2026.vue?vue&type=script&lang=js"
export * from "./CardTagRowV2026.vue?vue&type=script&lang=js"
import style0 from "./CardTagRowV2026.vue?vue&type=style&index=0&id=71ab8ef5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ab8ef5",
  null
  
)

export default component.exports